import React, { useEffect, useState, Fragment, useRef } from "react";
import { BlockPluckingReportTableContent } from '../../../Common/Table/tableContent';
import tokenService from '../../../../Common/tokenDecoder';

export default class ComponentToPrint extends React.Component {
    render() {
        const searchData = this.props.searchData;
        const data = this.props.dataOne;
        const contentRowNames = this.props.rowNames;
        const totalAmount = this.props.totalAmount;
        const keys = this.props.keys;

        return (
            <div>
                <h3><center><u>Block Plucking Report</u></center></h3>
                <div className="row pl-2 pb-4 pt-4">
                    <div className="col"><b>Group: </b> {searchData.group}</div>
                    <div className="col"><b>Operation Entity: </b> {searchData.estate}</div>
                    <div className="col"><b>Collection Point: </b> {searchData.division == undefined ? "All Collection Points" : searchData.division}</div>
                    <div className="col"><b>Date: </b> {searchData.date}</div>
                    <div className="col"><b>User: </b> {tokenService.getUserNameFromToken()}</div>
                    <div className="col"><b>Date/Time: </b> {new Date().toLocaleString()}</div>
                </div>

                {keys.map((e, index) => {
                    return (
                        <div key={index} className="row pt-2">
                            <div className="col width4">

                                <table className="display dataTable no-footer" id={e}>
                                    <thead>
                                        <tr>
                                            <th>Reg No</th>
                                            <th>Main Field</th>
                                            <th>Sub Field</th>
                                            <th>Total</th>
                                        </tr>
                                    </thead>

                                    <tbody>
                                        <BlockPluckingReportTableContent
                                            data={data[e]}
                                            contentRowNames={contentRowNames}
                                            hasEdit={false}
                                        />
                                    </tbody>
                                    <tfooter>
                                        <th>Total</th>
                                        <th></th>
                                        <th></th>
                                        <th>{totalAmount}</th>
                                    </tfooter>
                                </table>
                            </div>
                        </div>
                    )
                })}
            </div>
        );
    }
}